import { jsx as _jsx } from "react/jsx-runtime";
// TODO: fix proper types
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useI18N } from "@sundae/react-hooks";
import { WalletConnectDialog as ToolkitWalletConnect } from "@sundae/ui-toolkit";
import { useWalletLoadingState, useWalletObserver } from "@sundaeswap/wallet-lite";
import { useCallback, useState } from "react";
import { EEX_PATHS } from "../../../constants/paths";
import WalletConnectLegalDisclaimer from "../../../i18n/components/wallet/WalletConnectLegalDisclaimer";
import { Actions, useAppContext } from "../../../stores";
export const WalletConnectDialog = () => {
    const { t } = useI18N("wallet");
    const { state: { walletConnectOpen }, dispatch, } = useAppContext();
    const { connectWallet } = useWalletObserver();
    const { connectingWallet } = useWalletLoadingState();
    const [error, setError] = useState("");
    const handleConnect = useCallback(async (key) => {
        try {
            await connectWallet(key);
            Actions.setConnectWalletOpen(false, dispatch);
        }
        catch (e) {
            const error = e;
            if (error?.message && error?.message === "no account set") {
                setError(t("error.no_account"));
            }
        }
    }, []);
    return (_jsx(ToolkitWalletConnect, { noWalletsComponent: true, i18n: {
            error,
            learnMore: t("connect.learnMore"),
            description: t("connect.newToCardano"),
            noWallets: t("connect.noWallets"),
            title: t("connect.title"),
        }, legalDisclaimer: _jsx(WalletConnectLegalDisclaimer, {}), onConnectWallet: handleConnect, isLoading: connectingWallet, learnMoreRoute: EEX_PATHS.LEARN_MORE_WALLETS, onClose: () => Actions.setConnectWalletOpen(false, dispatch), open: walletConnectOpen }));
};
export default WalletConnectDialog;
//# sourceMappingURL=WalletConnectDialog.js.map